module.exports = "img/flags/ZM.12e45bf.png";